import React from "react";
import { Layout, Menu, Button, Avatar } from "antd";
import { SettingOutlined, WalletOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { storage } from "../utils/storage";

const { Sider, Content } = Layout;

const Navbar: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { logout } = useAuth0();
    const displayName = (storage.getUserName() || "").toString().trim() || (storage.getUserEmail() || "").toString().trim() || "User";

    const selectedKey = React.useMemo(() => {
        if (location.pathname.startsWith("/appconfiguration")) return "appconfiguration";
        if (location.pathname.startsWith("/solanawalletgenerator")) return "solanawalletgenerator";
        return "appconfiguration";
    }, [location.pathname]);

    const onClickMenu = ({ key }: { key: string }) => {
        if (key === "appconfiguration") navigate("/appconfiguration");
        if (key === "solanawalletgenerator") navigate("/solanawalletgenerator");
    };

    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Sider
                width={260}
                collapsedWidth={72}
                style={{ background: "#03b5d7", position: "relative" }}
            >
                <div style={{ height: 48, margin: 16, color: "#fff", fontWeight: 700, fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
                    Ailtra Bot
                </div>
                <Menu
                    theme="light"
                    mode="inline"
                    selectedKeys={[selectedKey]}
                    onClick={onClickMenu}
                    style={{ background: "white" }}
                    items={[
                        { key: "appconfiguration", icon: <SettingOutlined />, label: "App Configuration" },
                        { key: "solanawalletgenerator", icon: <WalletOutlined />, label: "Generate Solana Wallet" },
                    ]}
                />
                <div style={{ position: "absolute", left: 16, right: 16, bottom: 16 }}>
                    <Button
                        onClick={() => {
                            try { window.localStorage.clear(); } catch {}
                            logout({ logoutParams: { returnTo: window.location.origin } });
                        }}
                        style={{
                            width: "100%",
                            height: 48,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            gap: 12,
                            padding: "0 14px",
                            fontWeight: 700,
                            color: "#fff",
                            backgroundImage: "linear-gradient(to right, #00B4D8, #48CAB2)",
                            border: "none",
                            boxShadow: "0 8px 20px rgba(0,180,216,0.35)",
                            borderRadius: 12,
                        }}
                        icon={<Avatar size={28} src={storage.getUserProfilePicture()} icon={<UserOutlined />} />}
                    >
                        <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1 }}>{displayName}</span>
                        <LogoutOutlined />
                    </Button>
                </div>
            </Sider>
            <Layout>
                <Content style={{ padding: 0 }}>
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    );
};

export default Navbar;


